// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"bcebc0f8","110":"4c5549c3","123":"05838776","192":"38556e1c","227":"90eb188e","233":"4a86e3bf","378":"8e5eaeaf","454":"be93254e","765":"54d58b47","825":"92fea3e2","971":"9175ed2e"}[chunkId] + ".chunk.js";
};